import { ConfigType } from '../interface-type'

const Config: ConfigType = {
  version: "v1.0",
  vallarisUrl: "https://api.vallaris.space/v2",
  andamanUrl: "https://api.andaman.cloud",
  jetstreamUrl: "https://api.jetstream.gmbh"
};

export default Config;
